import { g as a } from "./global.js";
import { i as e } from "./is-callable.js";
var t = a.WeakMap,
  i = e(t) && /native code/.test(String(t));
export { i as w };